module.exports = __webpack_public_path__ + "img/l-t.a3b4f20f.png";